import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useGlobal, ProjectItem } from "../contexts/GlobalContext";

const LAST_PROJECT_KEY = "hm_last_project_key";

export const getLastProjectKey = (): string | null =>
  localStorage.getItem(LAST_PROJECT_KEY);

export const setLastProjectKey = (key: string) => {
  if (key) localStorage.setItem(LAST_PROJECT_KEY, key);
};

export interface CurrentProjectState {
  /** 路由 :projectKey 参数 */
  projectKey?: string;
  /** 命中的项目（projects 还在加载或 key 无效时为 undefined） */
  project?: ProjectItem;
  /** 是否全功能(PostChat)项目 */
  isPostchat: boolean;
  /** projects 列表是否仍在加载 */
  loading: boolean;
  /** 已加载完成但 key 找不到对应项目 */
  notFound: boolean;
}

// 从路由 :projectKey 解析当前项目；命中后记忆为 lastProjectKey（供旧路由重定向用）。
export function useCurrentProject(): CurrentProjectState {
  const { projectKey } = useParams<{ projectKey: string }>();
  const { projects, loading } = useGlobal();

  const project = useMemo(
    () => projects.find((p) => p.key_value === projectKey),
    [projects, projectKey]
  );

  useEffect(() => {
    if (project) setLastProjectKey(project.key_value);
  }, [project]);

  return {
    projectKey,
    project,
    isPostchat: !!project?.is_postchat,
    loading,
    notFound: !!projectKey && !loading && !project,
  };
}

// 在没有路由参数的上下文里（如旧路由重定向）拿一个合理的默认项目 key。
export function resolveDefaultProjectKey(projects: ProjectItem[]): string | null {
  const last = getLastProjectKey();
  if (last && projects.some((p) => p.key_value === last)) return last;
  return projects[0]?.key_value ?? null;
}
